<template>
  <v-container fluid>
    <v-row v-if="$store.getters.userConfig.isSupplier">
      <supplier-portal></supplier-portal>
    </v-row>

    <v-layout wrap v-else>
      <v-flex
        v-if="this.$store.getters.hasAccessTo('home_screen:show_tasks_first')"
      >
        <task-tracker-list></task-tracker-list>
      </v-flex>
      <v-flex text-xs-center xs12>
        <show-content title="" content-name="Landing Page"></show-content>
      </v-flex>
      <v-flex text-xs-center xs12>
        <show-content
          title=""
          owner="OWNER"
          content-name="Owner Notes"
          bg-color="green lighten-1"
        ></show-content>
      </v-flex>
      <v-flex
        v-if="
          this.$store.getters.hasAccessTo('plugins:task_tracker') &&
          !this.$store.getters.hasAccessTo('home_screen:show_tasks_first')
        "
      >
        <task-tracker-list></task-tracker-list>
      </v-flex>
      <v-flex xs12>
        <basic-components-list
          :list="allowedCharts"
          :visibleItems="chartsSettings.visibleItems"
          :columns="chartsSettings.columns"
          @change="onChartsSettingsChange"
        ></basic-components-list>
        <v-row v-if="debug">
          {{ chartsSettings }}
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ItinerariesByDestination from "../gt/dashboard/charts/ItinerariesByDestination";
import ItinerariesByStafff from "../gt/dashboard/charts/ItinerariesByStaff";
import SalesByStaff from "../gt/dashboard/charts/SalesByStaff";
import SalesByAgent from "../gt/dashboard/charts/SalesByAgent";
import ShowContent from "../gt/shared/ShowContent";
import BasicComponentsList from "../gt/shared/BasicComponentsList";
import charts from "../gt/dashboard/dashboard-charts";
import TaskTrackerList from "../gt/plugins/task-tracker/TaskTrackerList.vue";
import SupplierPortal from "../gt/supplier-portal/SupplierPortal.vue";
import postscribe from "postscribe";
export default {
  name: "home-page",

  components: {
    ItinerariesByDestination,
    ItinerariesByStafff,
    SalesByStaff,
    SalesByAgent,
    ShowContent,
    BasicComponentsList,
    TaskTrackerList,
    SupplierPortal,
  },

  data() {
    return {
      debug: false,
      drawer: null,
      charts: [...charts],
      chartsSettings: this.$store.getters.localSettings(
        "dashboardChartsSettings",
        {
          visibleItems: [
            "Itineraries by Destination",
            "Itineraries By Staff",
            "Sales By Staff",
          ],
          coumns: 2,
        }
      ),
    };
  },

  computed: {
    allowedCharts() {
      return this.charts.filter((c) =>
        this.$store.getters.hasAccessTo(c.accessSetting)
      );
    },
  },

  methods: {
    onChartsSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        dashboardChartsSettings: { ...payload },
      });
    },
  },
  mounted() {
    if (window.location.hostname.indexOf("pinkelephantinternational") > -1) {
      postscribe(
        "#addons",
        `<script>window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}<\/script><script id="zsiqscript" src="https://salesiq.zohopublic.com/widget?wc=siqdcd3c7d7aac593e0131ad648738a717deac73676e81948de444ba5914a77a60c1b7656ea2b1746bcdf9093d4bb8596ed" defer><\/script>`
      );
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue